import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  drivingLicenseFailure,
  drivingLicenseLoading,
  drivingLicenseSuccess,
  aadharCardFailure,
  aadharCardLoading,
  aadharCardSuccess,
  panCardFailure,
  panCardLoading,
  panCardSuccess,
} from '../../ducks/DocumentSlice';

// Driving License Handler
export function* handlerDrivingLicenseUpload(action: any): Generator<any, void, any> {
  try {
    yield put(drivingLicenseLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.drivinglicence}`, action.payload);
    
    if (response.success) {
      yield put(drivingLicenseSuccess(response.data));
    } else {
      yield put(drivingLicenseFailure(response.message || 'Driving license upload failed'));
    }
  } catch (error: any) {
    yield put(drivingLicenseFailure(error.message || 'Driving license upload failed'));
  }
}

// Aadhar Card Handler
export function* handlerAadharCard(action: any): Generator<any, void, any> {
  try {
    yield put(aadharCardLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.aadharcard}`, action.payload);
    
    if (response.success) {
      yield put(aadharCardSuccess(response.data));
    } else {
      yield put(aadharCardFailure(response.message || 'Aadhar card upload failed'));
    }
  } catch (error: any) {
    yield put(aadharCardFailure(error.message || 'Aadhar card upload failed'));
  }
}

// PAN Card Handler
export function* handlerPanCard(action: any): Generator<any, void, any> {
  try {
    yield put(panCardLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.pancard}`, action.payload);
    
    if (response.success) {
      yield put(panCardSuccess(response.data));
    } else {
      yield put(panCardFailure(response.message || 'PAN card upload failed'));
    }
  } catch (error: any) {
    yield put(panCardFailure(error.message || 'PAN card upload failed'));
  }
}
